export const isValidEmail = (email: string): boolean => {
  if (!email) return false;
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
};

export const isValidPhone = (phone: string): boolean => {
  if (!phone) return false;
  // Basic validation for Brazilian phone numbers (XX) XXXXX-XXXX or (XX) XXXX-XXXX
  const cleaned = phone.replace(/\D/g, '');
  return /^(\d{2})(\d{8,9})$/.test(cleaned);
};

export const isValidCPF = (cpf: string | undefined): boolean => {
  if (!cpf) return false;
  cpf = cpf.replace(/[^\d]+/g, '');
  if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;
  let sum = 0;
  let remainder;
  for (let i = 1; i <= 9; i++) sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i);
  remainder = (sum * 10) % 11;
  if ((remainder === 10) || (remainder === 11)) remainder = 0;
  if (remainder !== parseInt(cpf.substring(9, 10))) return false;
  sum = 0;
  for (let i = 1; i <= 10; i++) sum = sum + parseInt(cpf.substring(i - 1, i)) * (12 - i);
  remainder = (sum * 10) % 11;
  if ((remainder === 10) || (remainder === 11)) remainder = 0;
  if (remainder !== parseInt(cpf.substring(10, 11))) return false;
  return true;
};

export const isValidCEP = (cep: string): boolean => {
  if (!cep) return false;
  const cleaned = cep.replace(/\D/g, '');
  return cleaned.length === 8;
};

export const isValidCreditCardNumber = (cardNumber: string): boolean => {
  if (!cardNumber) return false;
  const cleaned = cardNumber.replace(/\D/g, '');
  // Basic Luhn algorithm check
  if (/[^0-9-\s]+/.test(cleaned)) return false;
  let nCheck = 0, bEven = false;
  for (var n = cleaned.length - 1; n >= 0; n--) {
    var cDigit = cleaned.charAt(n),
      nDigit = parseInt(cDigit, 10);
    if (bEven && (nDigit *= 2) > 9) nDigit -= 9;
    nCheck += nDigit;
    bEven = !bEven;
  }
  return (nCheck % 10) === 0;
};

export const isValidExpiryDate = (expiryDate: string): boolean => {
  if (!expiryDate) return false;
  
  // ✅ FORMATO MM/YY (ex: 12/25, 04/26)
  const match = expiryDate.match(/^(\d{2})\/(\d{2})$/);
  if (!match) return false;
  
  const month = parseInt(match[1], 10);
  const year = parseInt(match[2], 10);
  const currentYear = new Date().getFullYear() % 100; // Pega apenas os últimos 2 dígitos
  const currentMonth = new Date().getMonth() + 1;

  if (month < 1 || month > 12) return false;

  // ✅ Validação para formato YY (2 dígitos)
  if (year < currentYear || (year === currentYear && month < currentMonth)) {
    return false;
  }
  
  return true;
};

export const isValidCVV = (cvv: string): boolean => {
  if (!cvv) return false;
  const cleaned = cvv.replace(/\D/g, '');
  return cleaned.length >= 3 && cleaned.length <= 4;
};